/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export type DataSharingStats = {
  executed: number;
  shared: number;
};

export default class Request {
  constructor(
    public id: string,
    public configurations: Array<string>,
    public dataMappings: Array<string>,
    public dataSharingStats: DataSharingStats,
    public created: Date,
    public modified: Date,
    public title: string,
    public legalText: string
  ) {}

  static fromJSON(json: Record<string, any>): Request {
    /*
   {
          "id": "497f6eca-6276-4993-bfeb-53cbbbba6f08",
          "configurations": [
            "string"
          ],
          "data_mappings": [
            "497f6eca-6276-4993-bfeb-53cbbbba6f08"
          ],
          "data_sharing_stats": "string",
          "created": "2019-08-24T14:15:22Z",
          "modified": "2019-08-24T14:15:22Z",
          "title": "string"
    },
 * */

    return new Request(
      json.id,
      json.configurations,
      json.data_mappings,
      json.data_sharing_stats,
      json.created,
      json.modified,
      json.title,
      json.legal_text
    );
  }

  toJSON(): RequestUpdateData {
    return {
      id: this.id,
      title: this.title,
      legal_text: this.legalText,
    };
  }
}

export type RequestCreateData = {
  id?: string;
  configurations?: Array<string>;
  dataMappings?: Array<string>;
  title: string;
  legal_text: string;
};

export type RequestUpdateData = Partial<RequestCreateData>;
// & {
//   id: string;
// };

export type RequestDataFilter = "search";

// Backend keys you can sort with
export type RequestDataOrder =
  | "title"
  | "data_sharing__executed"
  | "data_sharing__shared"
  | "created";

// This will help transform the sorting from local to backend keys.
export const requestDataOrderTransform: Record<string, RequestDataOrder> = {
  title: "title",
  created: "created",
  executed: "data_sharing__executed",
  shared: "data_sharing__shared",
};

// These are the keys used for table listings
export type RequestDataTableFields = keyof typeof requestDataOrderTransform;

export type RequestQueryData = QueryData<RequestDataFilter, RequestDataOrder>;

export type RequestResponseData = ResponseData<
  Request,
  RequestDataFilter,
  RequestDataOrder
>;
